module.exports = __webpack_public_path__ + "static/uni_jackson-8dfad9187cab89026cb10c3ae072f0bd.png";